module.exports = __webpack_public_path__ + "media/images/pc/specials/fair/bg_03-986aab26762f3f6be1447a26120339a9.jpg";